/* eslint-disable */
export default {
  logged: '已记录',
  unlogged: '未记录',
  faxNotSupported: '不支持记录传真。',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
